<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
  </svg>
</template>

<script>
export default {
  name: 'IconPlusCircle',
  props: { className: { type: String, default: 'w-4 h-4' } },
}
</script>

